const glossary = {
  items: {
    businessType: {
      items: {
        BusinessType_NONE: {
          singular: '',
          plural: '',
        },
        RENTAL: {
          singular: 'Aluguel',
          plural: 'Aluguéis',
        },
        SALE: {
          singular: 'Venda',
          plural: 'Vendas',
        },
      },
    },
    amenity: {
      items: {
        GYM: {
          singular: 'Academia',
          plural: 'Academias',
        },
        POOL: {
          singular: 'Piscina',
          plural: 'Piscinas',
        },
      },
    },
    unitSubType: {
      items: {
        UnitSubType_NONE: {
          singular: 'Não informado',
          plural: 'Não informados',
        },
        RETAIL_CENTER: {
          singular: 'Centro comercial',
          plural: 'Centros comerciais',
        },
        PENTHOUSE: {
          singular: 'Cobertura',
          plural: 'Coberturas',
        },
        CONDOMINIUM: {
          singular: 'Condominio',
          plural: 'Condominios',
        },
        CLINIC: {
          singular: 'Consultório',
          plural: 'Consultórios',
        },
        DUPLEX: {
          singular: 'Duplex',
          plural: 'Duplex',
        },
        OFFICE: {
          singular: 'Escritório',
          plural: 'Escritórios',
        },
        FLAT: {
          singular: 'Flat',
          plural: 'Flats',
        },
        GALLERY: {
          singular: 'Galeria',
          plural: 'Galerias',
        },
        LOFT: {
          singular: 'Loft',
          plural: 'Lofts',
        },
        SHOPPING: {
          singular: 'Shopping',
          plural: 'Shoppings',
        },
        TWO_STORY_HOUSE: {
          singular: 'Sobrado',
          plural: 'Sobrados',
        },
        STUDIO: {
          singular: 'Studio',
          plural: 'Studios',
        },
        TRIPLEX: {
          singular: 'Triplex',
          plural: 'Triplex',
        },
        SINGLE_STOREY_HOUSE: {
          singular: 'Térrea',
          plural: 'Térreas',
        },
        VILLAGE_HOUSE: {
          singular: 'Vila/Rua Particular',
          plural: 'Vilas/Ruas Particulares',
        },
        KITNET: {
          singular: 'Kitnet/Conjugado',
          plural: 'Kitnets/Conjugados',
        },
        FLOOR: {
          singular: 'Andar/Laje corporativa',
          plural: 'Andares/Lajes corporativas',
        },
      },
    },
    unitType: {
      items: {
        UnitType_NONE: {
          singular: 'Não informado',
          plural: 'Não informados',
          unitSubTypes: [],
        },
        APARTMENT: {
          singular: 'Apartamento',
          plural: 'Apartamentos',
          unitSubTypes: [
            'PENTHOUSE',
            'FLAT',
            'LOFT',
            'STUDIO',
            'UnitSubType_NONE',
          ],
        },
        TWO_STORY_HOUSE: {
          singular: 'Sobrado',
          plural: 'Sobrados',
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        FLAT: {
          singular: 'Flat',
          plural: 'Flats',
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        KITNET: {
          singular: 'Kitnet/Conjugado',
          plural: 'Kitnets/Conjugados',
          deprecated: true,
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        HOME: {
          singular: 'Casa',
          plural: 'Casas',
          unitSubTypes: [
            'CONDOMINIUM',
            'TWO_STORY_HOUSE',
            'SINGLE_STOREY_HOUSE',
            'VILLAGE_HOUSE',
            'UnitSubType_NONE',
          ],
        },
        CONDOMINIUM: {
          singular: 'Casa de condomínio',
          plural: 'Casas de condomínio',
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        PENTHOUSE: {
          singular: 'Cobertura',
          plural: 'Coberturas',
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        RESIDENTIAL_ALLOTMENT_LAND: {
          singular: 'Lote/Terreno',
          plural: 'Lotes/Terrenos',
          deprecated: true,
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        COMMERCIAL_ALLOTMENT_LAND: {
          singular: 'Lote/Terreno',
          plural: 'Lotes/Terrenos',
          deprecated: true,
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        OFFICE: {
          singular: 'Sala/Conjunto',
          plural: 'Salas/Conjuntos',
          unitSubTypes: [
            'CLINIC',
            'OFFICE',
            'UnitSubType_NONE',
          ],
        },
        SHED_DEPOSIT_WAREHOUSE: {
          singular: 'Galpão/Depósito/Armazém',
          plural: 'Galpões/Depósitos/Armazéns',
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        STORE: {
          singular: 'Loja',
          plural: 'Lojas',
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        COMMERCIAL_BUILDING: {
          singular: 'Prédio/Edificio inteiro',
          plural: 'Prédios/Edificios inteiros',
          deprecated: true,
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        CLINIC: {
          singular: 'Consultório',
          plural: 'Consultórios',
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        BUSINESS: {
          singular: 'Ponto comercial/Loja/Box',
          plural: 'Pontos comerciais/Lojas/Boxes',
          unitSubTypes: [
            'RETAIL_CENTER',
            'GALLERY',
            'SHOPPING',
          ],
        },
        COUNTRY_HOUSE: {
          singular: 'Chácara',
          plural: 'Chácaras',
          deprecated: true,
          unitSubTypes: [
            'CONDOMINIUM',
            'UnitSubType_NONE',
          ],
        },
        FARM: {
          singular: 'Fazenda/Sítio/Chácara',
          plural: 'Fazendas/Sítios/Chácaras',
          unitSubTypes: [
            'CONDOMINIUM',
            'UnitSubType_NONE',
          ],
        },
        COMMERCIAL_PROPERTY: {
          singular: 'Imóvel comercial',
          plural: 'Imóveis comerciais',
          deprecated: true,
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        RESIDENTIAL_BUILDING: {
          singular: 'Edifício residencial',
          plural: 'Edifícios residenciais',
          deprecated: true,
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        DUPLEX: {
          singular: 'Duplex',
          plural: 'Duplex',
          deprecated: true,
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        TRIPLEX: {
          singular: 'Triplex',
          plural: 'Triplex',
          deprecated: true,
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        LOFT: {
          singular: 'Loft',
          plural: 'Lofts',
          deprecated: true,
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        VILLAGE_HOUSE: {
          singular: 'Vila/Rua Particular',
          plural: 'Vilas/Ruas Particulares',
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        HOTEL: {
          singular: 'Hotel/Motel/Pousada',
          plural: 'Hotéis/Motéis/Pousadas',
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        PARKING_SPACE: {
          singular: 'Garagem',
          plural: 'Garagens',
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        FLOOR: {
          singular: 'Andar/Laje corporativa',
          plural: 'Andares/Lajes corporativas',
          deprecated: true,
          unitSubTypes: [
            'UnitSubType_NONE',
          ],
        },
        ALLOTMENT_LAND: {
          singular: 'Lote/Terreno',
          plural: 'Lotes/Terrenos',
          unitSubTypes: [
            'CONDOMINIUM',
            'VILLAGE_HOUSE',
            'UnitSubType_NONE',
          ],
        },
        BUILDING: {
          singular: 'Prédio/Edifício inteiro',
          plural: 'Prédios/Edifícios inteiros',
          unitSubTypes: [],
        },
      },
    },
    state: {
      items: {
        AC: {
          singular: 'Acre',
        },
        AL: {
          singular: 'Alagoas',
        },
        AP: {
          singular: 'Amapá',
        },
        AM: {
          singular: 'Amazonas',
        },
        BA: {
          singular: 'Bahia',
        },
        CE: {
          singular: 'Ceará',
        },
        DF: {
          singular: 'Distrito Federal',
        },
        ES: {
          singular: 'Espírito Santo',
        },
        GO: {
          singular: 'Goiás',
        },
        MA: {
          singular: 'Maranhão',
        },
        MT: {
          singular: 'Mato Grosso',
        },
        MS: {
          singular: 'Mato Grosso do Sul',
        },
        MG: {
          singular: 'Minas Gerais',
        },
        PA: {
          singular: 'Pará',
        },
        PB: {
          singular: 'Paraíba',
        },
        PR: {
          singular: 'Paraná',
        },
        PE: {
          singular: 'Pernambuco',
        },
        PI: {
          singular: 'Piauí',
        },
        RJ: {
          singular: 'Rio de Janeiro',
        },
        RN: {
          singular: 'Rio Grande do Norte',
        },
        RS: {
          singular: 'Rio Grande do Sul',
        },
        RO: {
          singular: 'Rondônia',
        },
        RR: {
          singular: 'Roraima',
        },
        SC: {
          singular: 'Santa Catarina',
        },
        SP: {
          singular: 'São Paulo',
        },
        SE: {
          singular: 'Sergipe',
        },
        TO: {
          singular: 'Tocantins',
        },
      },
    },
    publicationType: {
      items: {
        PREMIUM: {
          singular: 'Destaque',
        },
      },
    },
    constructionStatus: {
      items: {
        UNDER_CONSTRUCTION: {
          singular: 'Em construção',
        },
      },
    },
    listingStatus: {
      items: {
        INACTIVE: {
          singular: 'Inativo',
        },
      },
    },
    publisherType: {
      items: {
        ABMI: {
          singular: 'Parceiro oficial',
          plural: 'Parceiros oficiais',
        },
      },
    },
  },
}

export default glossary
